<template>
  <div class="xwdtList">
    <div class="bt">
      <h3>教科研动态</h3>
      <span>DYNAMICS OF TEACHING AND RESEARCH</span>
      <img src="../assets/img/icon_bt.png" alt="" />
    </div>
    <div
      class="xskxBoxList"
      :style="{ position: 'relative', height: styles.height + 'rem' }"
    >
      <div
        class="swiper-container"
        :style="{
          width: styles.width + 'rem',
          position: 'absolute',
          height: styles.height + 'rem',
        }"
      >
        <div class="swiper-wrapper">
          <div
            v-for="(item, index) in parseInt(xwdtList.length / 2)"
            :key="index"
            class="swiper-slide flexDiv"
          >
            <div class="xskx_text">
              <router-link
                :to="xwdtList[index * 2 + 0].Url"
                :href="xwdtList[index * 2 + 0].Url"
                @click.native="OpenLink(xwdtList[index * 2 + 0].Url)"
              >
                <div class="xskx_img">
                  <img :src="xwdtList[index * 2 + 0].Cover" />
                </div>
                <div class="xskx_title">
                  <h4 class="txt-cut1">{{ xwdtList[index * 2 + 0].Title }}</h4>
                  <p class="txt-cut2">{{ xwdtList[index * 2 + 0].Describe }}</p>
                  <em>{{
                    setTimeformat(
                      xwdtList[index * 2 + 0].ShowTime,
                      "yyyy-mm-dd"
                    )
                  }}</em>
                  <span>查看更多>></span>
                </div>
              </router-link>
            </div>
            <div class="xskx_text">
              <router-link
                :to="xwdtList[index * 2 + 1].Url"
                :href="xwdtList[index * 2 + 1].Url"
                @click.native="OpenLink(xwdtList[index * 2 + 1].Url)"
              >
                <div class="xskx_img">
                  <img :src="xwdtList[index * 2 + 1].Cover" />
                </div>
                <div class="xskx_title">
                  <h4 class="txt-cut1">{{ xwdtList[index * 2 + 1].Title }}</h4>
                  <p class="txt-cut2">{{ xwdtList[index * 2 + 1].Describe }}</p>
                  <em>{{
                    setTimeformat(
                      xwdtList[index * 2 + 1].ShowTime,
                      "yyyy-mm-dd"
                    )
                  }}</em>
                  <span>查看更多>></span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <!-- <div  v-if="sliderList.length>1" class="swiper-button-prev" style="left: 50%; margin-left: -620px"></div>
        <div  v-if="sliderList.length>1" class="swiper-button-next" style="left: 50%; margin-left: 600px"></div> -->

        <!-- 如果需要滚动条 -->
        <!-- <div class="swiper-scrollbar"></div> -->
      </div>
    </div>
    <div v-if="moreLink" class="more wow zoomIn" data-wow-delay="0.3s">
      <router-link :to="moreLink"><em>查看更多></em></router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "xwdt",
  props: {
    xwdtList: {
      // 图片列表 src数组
      type: Array,
      default: () => [],
    },
    moreLink: {
      type: String,
      default: "",
    },
    isShowPosition: {
      // 是否显示下方小圆点
      type: Boolean,
      default: true,
    },
    isShowLeftOrRightBtn: {
      // 是否显示左右按钮
      type: Boolean,
      default: true,
    },
    duration: {
      // 切换间隔
      type: [Number, String],
      default: 5000,
    },
    animationT: {
      type: Object,
      default: () => {
        return {
          speed: 20,
          speedTime: 20,
        };
      },
    },
    styles: {
      // 自定义轮播图片宽高 默认500*300
      type: Object,
      default: () => {
        return {
          width: 6.9,
          height: 4.93,
        };
      },
    },
  },
  methods: {
    setTimeformat(_data, _format = "yyyy-mm-dd") {
      return _format
        .replace(/YYYY/i, _data.substr(0, 4))
        .replace(/MM/i, _data.substr(5, 2))
        .replace(/DD/i, _data.substr(8, 2));
    },
    hoverRoll(_data) {
      this.item = _data;
    },
  },
  data() {
    return {
      active: 1, // 当前轮播图片
      timer: null, // 定时器
      len: 1,
      screenWidthtimer: false,
      screenWidth: document.body.clientWidth, // 屏幕宽度
    };
  },
  mounted() {
    if (this.xwdtList.length > 1) {
      var mySwiper4 = new Swiper(".xskxBoxList .swiper-container", {
        autoplay: false,
        direction: "horizontal",
        loop: true, // 循环模式选项
        // 如果需要分页器
        pagination: ".xskxBoxList .swiper-pagination",
        // 如果需要前进后退按钮

        nextButton: ".xskxBoxList .swiper-button-next",
        prevButton: ".xskxBoxList .swiper-button-prev",
      });
    }
  },
};
</script>
<style>
.xwdtList {
  width: 6.9rem;
}
.xwdtList .xskxBoxList {
  margin-bottom: 0.2rem;
}
.xwdtList .xskxBoxList .swiper-container {
  width: 100%;
  height: 4.93rem;
}
.xwdtList .xskxBoxList .swiper-container .swiper-wrapper {
  width: 100%;
  height: 4.93rem;
}
.xwdtList .swiper-slide {
  height: 4.27rem;
}
.xwdtList .swiper-slide .xskx_text {
  width: 3.3rem;
  margin: 0;
  box-sizing: border-box;
}
.xwdtList .xskx_text .xskx_img img {
  width: 3.3rem;
  height: 2.27rem;
  display: block;
  object-fit: cover;
}
.xwdtList .xskx_text .xskx_title {
  width: 3.3rem;
  height: 2rem;
  padding: 0.2rem;
  box-sizing: border-box;
}
.xwdtList .xskx_text .xskx_title h4 {
  font-size: 0.26rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.28rem;
  letter-spacing: 0.02rem;
  color: #333333;
  margin-bottom: 0.2rem;
}
.xwdtList .xskx_text .xskx_title p {
  font-size: 0.24rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.34rem;
  letter-spacing: 0.02rem;
  color: #666666;
  margin-bottom: 0.2rem;
}
.xwdtList .xskx_text .xskx_title em {
  font-size: 0.22rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.2rem;
  letter-spacing: 0.01rem;
  color: #999999;
  display: inline-block;
}
.xwdtList .xskx_text .xskx_title span {
  display: inline-block;
  font-size: 0.2rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.2rem;
  letter-spacing: 0.01rem;
  color: #999999;
  margin-left: 0.35rem;
}
.xwdtList .more {
  width: 2rem;
  height: 0.7rem;
  border-radius: 0.05rem;
  border: solid 0.01rem #0376be;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5rem;
  box-sizing: border-box;
}
.xwdtList .more a {
  display: block;
  font-size: 0.26rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.68rem;
  letter-spacing: 0.03rem;
  color: #0376be;
  text-align: center;
}
.xwdtList .swiper-pagination,
.swiper-pagination-bullets {
  font-size: 0 !important;
  bottom: 0.1rem !important;
}
.xwdtList .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 0.16rem !important;
  height: 0.16rem !important;
  background-color: #0376be !important;
  border-radius: 0.08rem !important;
  opacity: 1 !important;
}
.xwdtList .swiper-pagination-bullet {
  width: 0.16rem !important;
  height: 0.16rem !important;
  background-color: #ffffff !important;
  border: #0376be 0.01rem solid !important;
  opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/xwdt.vue